import { render, staticRenderFns } from "./LineLink.vue?vue&type=template&id=60f19f45&"
import script from "./LineLink.vue?vue&type=script&lang=js&"
export * from "./LineLink.vue?vue&type=script&lang=js&"
import style0 from "./LineLink.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/opt/build/repo/storefront/components/atoms/Link/BaseLink.vue').default})
